/* eslint-disable no-prototype-builtins */
import { SendReturnResult, SendReturn } from "./types";

export function parseSendReturn(
  sendReturn: SendReturnResult | SendReturn
): any {
  return sendReturn.hasOwnProperty("result") ? sendReturn.result : sendReturn;
}

export class NoEthereumProviderError extends Error {
  public constructor() {
    super();
    this.name = this.constructor.name;
    this.message = "Connector not found.";
  }
}

export class UserRejectedRequestError extends Error {
  public constructor() {
    super();
    this.name = this.constructor.name;
    this.message = "The user rejected the request.";
  }
}
